module.exports = __webpack_public_path__ + "static/media/screen_share.a3ef917e.svg";